module.exports = __webpack_public_path__ + "img/page_head_02.fa5de829.png";